import React, { useState } from 'react';

const ResourceCard = ({ title, iconSrc, link, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const cardStyle = {
    border: isHovered ? '1px solid #6E4884' : '1px solid #d5b3e7',
    boxShadow: isHovered ? '5px 5px 15px grey' : '0 4px 12px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    width: '150px', 
    position: 'relative',
    margin: '20px', 
    borderRadius: '20px',
    backgroundColor: '#D5B3E7', 
    padding: '40px', 
    textAlign: 'center', 
    display: 'flex', 
    width: "90%",
    height: "25vh", 
    justifyContent: 'space-around', 
    alignItems: 'center',
    cursor: 'pointer', 
  };
    
  const iconStyle = (name) => {
    if (name.includes('2nd-icon.png')) {
        return {
          alignSelf: 'center',
          margin: '10px 0',
        };
      } else {
        return {
          position: 'absolute',
          width: '70px',
          height: '70px',
          top: '10px',
          left: '10px',
        };
      }
    }

    const iconStyleBottom = (name) => {
        return {
        position: 'absolute',
        width: '70px',
        height: '70px',
        bottom: '10px',
        right: '10px',
        transform: 'rotate(180deg)'
        };
    }

    const [hover, setHover] = useState(false);

    return (
      
        <div style={cardStyle} onClick={onClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
          {<img src={process.env.PUBLIC_URL + iconSrc} alt="Card icon" style={iconStyle(iconSrc)}/>}
          <a href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontWeight: 'bold', fontSize: '25px', color: '#6E4884', textDecoration: hover ? 'underline' : 'none',}}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}>
              {title}
          </a>
          {!iconSrc.includes('2nd-icon.png') && <img src={process.env.PUBLIC_URL + iconSrc} alt="Card icon" style={iconStyleBottom(iconSrc)}/>}
          </div>
    );
};

export default ResourceCard;
